<template>
	<div id="cl-ar-chart-modal-widget">
		<h3 class="module-title">
			Growth of a hypothetical $10,000 investment
			<slot name="superscript6" />
		</h3>
		<ReadMoreLink />
		<div>
			<p class="chart-description">
				This chart tracks a Class {{ shareClass }} share investment over the last 20 years, or, since inception date if the fund
				has been in existence under 20 years.
			</p>
		</div>
		<div class="chart-legend">
			<div class="item">
				<span class="square bg-brand-primary" />
				<span>{{ primaryIdentifier }}</span>
			</div>
			<div class="item">
				<span class="square bg-neutral-primary" />
				<span class="index">Index</span>
				<slot name="growthIndexId" />
				<div class="dropdown">
					<select>
						<option>{{ indexName }}</option>
					</select>
				</div>
				<slot name="superscript7" />
				<slot name="annualReturnsIndexId" />
			</div>
		</div>
		<div>
			<img :src="growthLargeChart" />
		</div>
	</div>
</template>

<script>
import ReadMoreLink from '_components_/Shared/ReadMoreLink';
export default {
	name: 'GrowthLargeChart',
	components: {
		ReadMoreLink
	},
	props: ['widgetData'],
	computed: {
		componentData() {
			return this.widgetData || {};
		},
		shareClass() {
			return this.componentData.shareClass || '';
		},
		fundName() {
			return this.componentData.fundName || '';
		},
		fundSymbol() {
			return this.componentData.fundSymbol || '';
		},
		indexName() {
			return this.componentData.indexName || '';
		},
		growthLargeChart() {
			return this.componentData.growthLargeChart;
		},

		//return fundName (fundSymbol) if both values are available
		//return fundName if only fundName is available
		//return fundSymbol if only fundSymbol is available
		//return -- if neither is available
		primaryIdentifier() {
			if (this.fundName && this.fundSymbol) {
				return `${this.fundName} (${this.fundSymbol})`;
			} else if (this.fundName) {
				return this.fundName;
			} else if (this.fundSymbol) {
				return this.fundSymbol;
			}
			return '--';
		}
	}
};
</script>

<style scoped lang="less">
#cl-ar-chart-modal-widget {
	.read-disclosures-link {
		margin-bottom: 20px;
		a {
			cursor: pointer;
			font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
			font-weight: 700;
		}
	}
	.chart-description {
		color: #333;
		font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
		font-size: 14px;
		font-weight: 400;
		margin-bottom: 20px;
	}
	.chart-legend {
		color: #666;
		font-family: 'AvenirNextLTW01-Regular', Arial, sans-serif;
		margin-bottom: 10px;
		.item {
			display: inline-block;
			margin-right: 15px;
		}
		.dropdown {
			margin-right: 5px;
		}
	}
	img {
		width: 100%;
	}
	@media (max-width: 768px) {
		.chart-legend {
			.dropdown {
				display: inline;
				select {
					width: 70%;
				}
			}
			.item {
				display: block;
			}
		}
	}
}
</style>
